export enum SubmitAction {
  ADD_OR_UPDATE = 'ADD_OR_UPDATE',
  REPLACE = 'REPLACE',
  FORCE_CREATION = 'FORCE_CREATION',
}
